import {errorHandler} from "./common";

const axios = require('axios');

export function getMetasByType(type) {
  return new Promise(function (resolve, reject) {
    console.log("getMatasByType ")
    axios.get(process.env.ROOT_API + 'admin/metas?type=' + type, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("getMatasByType response");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject()
      });
  })
}

export function getMetaByType(type) {
  return new Promise(function (resolve, reject) {
    console.log("getMatasByType ")
    axios.get(process.env.ROOT_API + 'meta/type/' + type, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("getMatasByType response");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject()
      });
  })
}
export function updateMetaItem(meta) {
  return new Promise(function (resolve, reject) {
    console.log("updateMetaItem ")
    axios.post(process.env.ROOT_API + 'admin/meta', JSON.stringify(meta), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Meta update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject()
      });
  })
}

export function deleteMeta(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/meta?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Meta delete");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to delete");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/meta.js